import type { AuthResponse } from '../@types/AuthResponse';

const filterAuthResponse = (response?: AuthResponse): AuthResponse => {
  const {
    token = '',
    deviceDataToken = '',
    errors,
    userManagement,
    sessionId,
  } = response ?? {};
  return {
    token,
    deviceDataToken,
    errors,
    userManagement,
    sessionId,
  };
};

export default filterAuthResponse;
